import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Sparkles, Images } from 'lucide-react';
import { Lightbox } from './Lightbox';
const fairyImages = ['https://cdn.magicpatterns.com/uploads/n4AejvBk5XuQRDKkGH8MN9/DSC_8291.jpg', 'https://cdn.magicpatterns.com/uploads/ujogouRxG8MXQN9kE5SQbj/DSC_7766.jpg', 'https://cdn.magicpatterns.com/uploads/n2qSmXNne3QCMdnGy5A6wz/DSC_8047.jpg', 'https://cdn.magicpatterns.com/uploads/dYUrVHgG8vftosXvoczxoD/Screenshot_2026-06-08_at_5.48.51_PM.png', 'https://cdn.magicpatterns.com/uploads/h8N14Y5NBUPoJjo5LEdWVu/DSC_7767.jpg', 'https://cdn.magicpatterns.com/uploads/j2g3dwsmnntxSz719AfmgE/DSC_7716.jpg', 'https://cdn.magicpatterns.com/uploads/5yWpEbkX21BguMoQdCZ8KZ/ChatGPT_Image_Jun_8,_2026_at_06_34_44_PM.png', 'https://cdn.magicpatterns.com/uploads/uKNUd2DQyCHa4HBXHec97w/DSC_7853.png', 'https://cdn.magicpatterns.com/uploads/uGRQzdWXNQo6H9gp1KDL9x/DSC_8064.jpg', 'https://cdn.magicpatterns.com/uploads/jjhQ7dKjZEXWF5M7WHzLVo/DSC_7762.jpg', 'https://cdn.magicpatterns.com/uploads/wUFjq6X1EzxaJ64TGvGZwc/DSC_8048.jpg', 'https://cdn.magicpatterns.com/uploads/d6JTcrPN4XxHcaVkeNXEvS/IMG_1478.jpg', 'https://cdn.magicpatterns.com/uploads/iGFeXUcE2FY1SoH2iLd1o8/cotton_candy.png', 'https://cdn.magicpatterns.com/uploads/aMNBSZ3YxjGBVPoEw8fG9P/tent_with_blanket.png'];
const themes = [{
  id: 'fairy',
  title: 'Enchanted Fairy',
  tag: 'Signature Theme',
  description: 'Our signature theme that started it all. A delicate woodland setting filled with sheer wings, twinkling lights, mossy accents, and touches of gold. Perfect for a gentle first birthday.',
  images: fairyImages.slice(0, 4),
  galleryImages: fairyImages,
  isAvailable: true
}, {
  id: 'farmer',
  title: 'Little Farmer',
  isAvailable: false
}, {
  id: 'teddy',
  title: 'Teddy Bear Picnic',
  isAvailable: false
}];
export function Themes() {
  const [activeId, setActiveId] = useState(themes[0].id);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const theme = themes.find(t => t.id === activeId) ?? themes[0];
  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };
  const selectTheme = (id: string) => {
    setActiveId(id);
    setLightboxOpen(false);
    setLightboxIndex(0);
  };
  return <section id="themes" className="py-24 md:py-28 bg-warm-ivory relative" data-id="element-158" data-mp="15siykq5k3a1y">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-159" data-mp="1joo6ohd6eo9z">
        <div className="text-center mb-16 relative" data-id="element-160" data-mp="1fpf9t3muaaa7">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="inline-block mb-6" data-id="element-161" data-mp="1fmt4zbrc28vo">
            
            <Sparkles className="w-6 h-6 text-[#FF83B4] mx-auto" strokeWidth={1} data-id="element-162" data-mp="23c412fxqnf3h" />
            
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="md:text-5xl text-soft-terracotta mb-6 font-normal text-[40px] font-[Merriweather,_serif]" data-id="element-163" data-mp="2i0x95d0u3fgh">
            
            Curated Themes
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-soft-dark text-lg max-w-2xl mx-auto font-light" data-id="element-164" data-mp="2d0j3g1mpghlm">
            
            Each celebration is styled with care, featuring premium décor and
            thoughtful details.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-6 inline-block rounded-full border border-soft-rose/30 bg-soft-rose-tint/60 px-6 py-3 text-soft-rose text-base md:text-lg italic font-[Merriweather,_serif]" data-id="element-165" data-mp="1fe25cu65dzyt">
            
            Have a theme in mind? We'd love to design it for you.
          </motion.p>
        </div>

        {/* Theme Selector — pill buttons matching the hero CTA shape */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-12" role="tablist" aria-label="Select a party theme" data-id="element-166" data-mp="28xbu96u9hazy">
          
          {themes.map(t => {
          const isActive = t.id === activeId;
          return <button key={t.id} role="tab" aria-selected={isActive} aria-disabled={!t.isAvailable} disabled={!t.isAvailable} onClick={() => selectTheme(t.id)} className={`px-7 py-3 text-sm uppercase tracking-widest font-medium rounded-full transition-all shadow-sm ${isActive ? 'bg-soft-terracotta text-white' : t.isAvailable ? 'bg-white text-soft-dark border border-soft-terracotta/20 hover:border-soft-terracotta/50 hover:text-soft-terracotta' : 'bg-white/60 text-soft-muted border border-soft-terracotta/10 cursor-not-allowed'}`} data-id="element-167" data-mp="3pdo8mkznosvi">
                
                {t.title}
                {!t.isAvailable && <span className="ml-2 text-[10px] tracking-[0.12em]" data-id="element-168" data-mp="38zi4zbd0bhil">TBD</span>}
              </button>;
        })}
        </motion.div>

        {/* Theme Module — swaps with the selected theme */}
        <AnimatePresence mode="wait" data-id="element-169" data-mp="3iwmrjcarlezx">
          <motion.div key={theme.id} initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -16
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex flex-col lg:flex-row gap-16 items-center p-8 md:p-16 rounded-3xl bg-soft-cream border border-soft-terracotta/10 shadow-sm" data-id="element-170" data-mp="3ivl3864qmw09">
            
            {/* Text Content */}
            <div className="w-full lg:w-1/3 space-y-8" data-id="element-171" data-mp="2u90f16jblmgj">
              <span className="inline-block font-medium uppercase tracking-[0.2em] px-4 py-1.5 rounded-full text-xs text-soft-rose border border-soft-rose/30 bg-soft-rose-tint/50" data-id="element-172" data-mp="2ucfysmnxvjoa">
                {theme.tag}
              </span>
              <h3 className="md:text-5xl font-normal text-soft-terracotta text-[40px] font-[Merriweather,_serif]" data-id="element-173" data-mp="2ghvmspia7wg8">
                {theme.title}
              </h3>
              <p className="text-soft-dark font-light text-[16px]" data-id="element-174" data-mp="2bhr5ix9juxoy">
                {theme.description}
              </p>
              <motion.a whileHover={{
              x: 4
            }} href="#contact" className="inline-flex items-center gap-2 font-medium text-sm uppercase tracking-widest text-powder-blue hover:opacity-80 transition-opacity group mt-4" data-id="element-175" data-mp="2kkig6uulppfj">
                
                Inquire about this theme
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} data-id="element-176" data-mp="1iom89rwspte4" />
                
              </motion.a>

              <div className="pt-2 hidden lg:flex justify-start" data-id="element-177" data-mp="1nh72gujm68i6">
                <button onClick={() => openLightbox(0)} className="inline-flex items-center gap-2 bg-white text-soft-terracotta px-6 py-3 text-sm uppercase tracking-widest font-medium rounded-full shadow-sm border border-soft-terracotta/20 hover:bg-soft-terracotta hover:text-white transition-all" data-id="element-178" data-mp="18s11p254oa86">
                  
                  <Images className="w-4 h-4" data-id="element-179" data-mp="26e88miowmenp" />
                  See More
                </button>
              </div>
            </div>

            {/* Image Gallery */}
            <div className="w-full lg:w-2/3 relative" data-id="element-180" data-mp="1wfrc767757u9">
              {/* Mobile — swipeable carousel through the full gallery */}
              <div className="sm:hidden -mx-8" data-id="element-181" data-mp="g0r8h5tkt3bv">
                <ul className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth px-8 pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" data-id="element-182" data-mp="l15c8bo59r43">
                  {theme.galleryImages.map((image, i) => <li key={image} className="snap-center shrink-0 w-[82%]" data-id="element-183" data-mp="3tg4b1zg6kp2x" data-mpi={i}>
                      <button type="button" onClick={() => openLightbox(i)} className="block w-full rounded-2xl overflow-hidden shadow-sm border border-white/50 focus:outline-none focus:ring-2 focus:ring-soft-terracotta" aria-label={`View ${theme.title} photo ${i + 1} of ${theme.galleryImages.length}`} data-id="element-184" data-mp="3ohjc03co0bg2">
                        <img src={image} alt={`${theme.title} detail ${i + 1}`} className="w-full h-72 object-cover" loading={i > 1 ? 'lazy' : undefined} data-id="element-185" data-mp="g1zkp9vk133n" />
                      </button>
                    </li>)}
                </ul>
                <p className="mt-4 text-center text-xs uppercase tracking-[0.18em] text-soft-muted" data-id="element-186" data-mp="79fumxtbw6uf">
                  Swipe to explore · {theme.galleryImages.length} photos
                </p>
              </div>

              <div className="hidden sm:grid grid-cols-2 gap-4 md:gap-6" data-id="element-187" data-mp="yztzy5na0auh">
                <div className="space-y-4 md:space-y-6" data-id="element-188" data-mp="2hp6ncr9zp3bl">
                  <motion.img whileHover={{
                  scale: 1.01
                }} transition={{
                  duration: 0.4
                }} src={theme.images[0]} alt={`${theme.title} detail`} className="w-full h-64 object-cover rounded-2xl shadow-sm border border-white/50 cursor-pointer" onClick={() => openLightbox(0)} data-id="element-189" data-mp="2mmonpt9xya7z" />
                  
                  <motion.img whileHover={{
                  scale: 1.01
                }} transition={{
                  duration: 0.4
                }} src={theme.images[1]} alt={`${theme.title} detail`} className="w-full h-80 object-cover rounded-2xl shadow-sm border border-white/50 cursor-pointer" onClick={() => openLightbox(1)} data-id="element-190" data-mp="30mhchj1wqgdb" />
                  
                </div>
                <div className="space-y-4 md:space-y-6 pt-8 md:pt-12" data-id="element-191" data-mp="3jejtivignyo3">
                  <motion.img whileHover={{
                  scale: 1.01
                }} transition={{
                  duration: 0.4
                }} src={theme.images[2]} alt={`${theme.title} detail`} className="w-full h-80 object-cover rounded-2xl shadow-sm border border-white/50 cursor-pointer" onClick={() => openLightbox(2)} data-id="element-192" data-mp="3obscgybfo6qe" />
                  
                  <div className="relative group rounded-2xl overflow-hidden shadow-sm border border-white/50 cursor-pointer" onClick={() => openLightbox(3)} data-id="element-193" data-mp="2ea2ao55pzbxr">
                    
                    <motion.img whileHover={{
                    scale: 1.05
                  }} transition={{
                    duration: 0.6
                  }} src={theme.images[3]} alt={`${theme.title} detail`} className="w-full h-64 object-cover" data-id="element-194" data-mp="2o1ghky003e0x" />
                    
                    <div className="absolute inset-0 bg-soft-dark/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-195" data-mp="3206f2eqqffpt">
                      <div className="flex flex-col items-center text-white" data-id="element-196" data-mp="17mx1obv2fa2a">
                        <Images className="w-8 h-8 mb-2" strokeWidth={1.5} data-id="element-197" data-mp="103xjg9jcboki" />
                        <span className="text-sm font-medium uppercase tracking-widest" data-id="element-198" data-mp="1060h9fqqilzs">
                          +{theme.galleryImages.length - 4} More
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* See More — tablet and below, beneath the images */}
              <div className="mt-8 flex justify-center lg:hidden" data-id="element-199" data-mp="1j1ia9m5o0x7r">
                <button onClick={() => openLightbox(0)} className="inline-flex items-center gap-2 bg-white text-soft-terracotta px-6 py-3 text-sm uppercase tracking-widest font-medium rounded-full shadow-sm border border-soft-terracotta/20 hover:bg-soft-terracotta hover:text-white transition-all" data-id="element-200" data-mp="1e3701abgkkp0">
                  
                  <Images className="w-4 h-4" data-id="element-201" data-mp="3utdq2gh7zb9l" />
                  See More
                </button>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <Lightbox images={theme.galleryImages} currentIndex={lightboxIndex} isOpen={lightboxOpen} onClose={() => setLightboxOpen(false)} onNavigate={setLightboxIndex} data-id="element-202" data-mp="3ra542xdsiy3q" />
      
    </section>;
}